export default "__VITE_ASSET__DphIaP7X__"